export interface StatusBadgeConfig {
    label: string;
    bgColor: string;
    textColor: string;
    borderColor: string;
    status: string;
}

export const invoiceStatusBadges: Record<string, StatusBadgeConfig> = {
    processing: {
        label: "Processing",
        bgColor: "bg-[#b8dbff]",
        textColor: "text-[#0000ff]",
        borderColor: "border-[#0000ff]",
        status: "processing",
    },
    failed: {
        label: "Failed",
        bgColor: "bg-red-200",
        textColor: "text-red-600",
        borderColor: "border-red-600",
        status: "failed",
    },
    review_required: {
        label: "For Review",
        bgColor: "bg-[#ffd19a]",
        textColor: "text-orange-500",
        borderColor: "border-orange-500",
        status: "review_required",
    },
    reviewed: {
        label: "Reviewed",
        bgColor: "bg-[#c4e8d1]",
        textColor: "text-green-600",
        borderColor: "border-green-600",
        status: "reviewed",
    },
    exported: {
        label: "Exported",
        bgColor: "bg-neutral-100",
        textColor: "text-neutral-500",
        borderColor: "border-neutral-500",
        status: "exported",
    },
};

export const defaultStatusBadge: StatusBadgeConfig = {
    label: "Unknown",
    bgColor: "bg-gray-100",
    textColor: "text-gray-600",
    borderColor: "border-gray-600",
    status: "unknown",
};

export function getInvoiceStatusBadge(status: string | undefined | null): StatusBadgeConfig {
    if (!status) {
        return invoiceStatusBadges.review_required;
    }
    return invoiceStatusBadges[status] || {
        ...defaultStatusBadge,
        label: status.replace("_", " "),
        status,
    };
}

// Array of all status badges for use in legends/filters
export const statusBadgesList: StatusBadgeConfig[] = Object.values(invoiceStatusBadges);
